import React, { useEffect } from "react";
import "./Footer.css";
import { FaEnvelope, FaPhoneAlt } from "react-icons/fa";

import { FaLocationDot } from "react-icons/fa6";

import { Link } from "react-router-dom";
import Logo from "../../Assets/logo.png";
import { useDispatch, useSelector } from "react-redux";
import { getFooter } from "../../Redux/Slices/AppSlices";

const Footer = () => {
  const dispatch = useDispatch();

  const { footer } = useSelector((state) => state.app);

  useEffect(() => {
    dispatch(getFooter());
  }, [dispatch]);

  if (!footer) return null;

  return (
    <footer className="footer">
      <div className="footer-top landing-pages">
        {/* LEFT */}
        <div className="footer-col box1">
          <img className="footer-logo" src={Logo} alt="logo" />

          <p>{footer?.description}</p>
        </div>

        {/* QUICK LINKS */}
        <div className="footer-col box2">
          <h4>Quick Links</h4>

          <ul className="footer-navitems">
            {footer?.quickLink?.map((item) => (
              <li key={item.id}>
                <Link to={`/${item.link}`}>{item.text}</Link>
              </li>
            ))}
          </ul>
        </div>

        {/* CONTACT */}
        <div className="footer-col box2">
          <h4>Support</h4>

          <ul className="footer-contact">
            {footer?.contactItem?.map((item) => (
              <li key={item.id}>
                <span>
                  {item.type === "phone" && <FaPhoneAlt />}

                  {item.type === "email" && <FaEnvelope />}

                  {item.type === "location" && <FaLocationDot />}
                </span>

                {item.type === "phone" && (
                  <a href={`tel:${item.link}`}>{item.link}</a>
                )}

                {item.type === "email" && (
                  <a href={`mailto:${item.link}`}>{item.link}</a>
                )}

                {item.type === "location" && `${item.link}`}
              </li>
            ))}
          </ul>
        </div>
      </div>

      {/* BOTTOM */}
      <div className="footer-bottom">
        <div className="footer-bottom landing-pages">
          <p>© 2026 The Kindergarten International | All rights reserved.</p>

          <p>
            Developed by : <span>Digital Dezire</span>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
